export default {
  state: {
    siteList: [
      { id: 'kasinohai', name: 'Kasinohai' },
      { id: 'casinobernie', name: 'CasinoBernie' },
      { id: 'casinovibez', name: 'CasinoVibez' },
      { id: 'casinokokemus', name: 'CasinoKokemus' },
      { id: 'uusimmatkasinot', name: 'Uusimmatkasinot' },
      { id: 'bogdancazino', name: 'Bogdancazino' },
    ],
  },
  getters: {
    siteList(state) {
      return state.siteList
    },
  },
}
